import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface OpeningBalanceTestingRommsProps {
  onBack: () => void;
}

export default function OpeningBalanceTestingRomms({ onBack }: OpeningBalanceTestingRommsProps) {
  return <PayrollRomms onBack={onBack} onComplete={() => {}} workspace="Opening Balance Testing" />;
}
